module.exports = __webpack_public_path__ + "static/media/15.7d834fa8.jpeg";